/**
 * Script that adds rel attribute with nofollow value to anchor links that match selection.
 * Helps with limiting spent crawl budget.
 */

const $selection = $('a[target="_blank"]'),
    exclude = ['flagshipamsterdam.', 'amsterdamboatexperience.', 'booot.', 'sloephurenamsterdam.', 'flagshipbiketoursamsterdam', 'dbk.', 'goo.gl', 'tripadvisor.', 'facebook.', 'twitter.', 'linkedin.', 'instagram.', 'youtube.']; // add strings to search for in anchor href attribute (url) for exclusion

$selection.each(function() {
    let $link = $(this),
        href = $(this).attr('href');

    let i,
        addNoFollow = true;

    for (i = 0; i < exclude.length; ++i) { // loop through exclude array and check if strings exists within href
        let str = exclude[i];

        if (href.indexOf(str) >= 0) { // if href contains string from the exclude list, dont add nofollow attribute to this link
            addNoFollow = false;
        }
    }

    if (addNoFollow) {
        $link.attr('rel', 'nofollow');
    }
});
